import styled from "styled-components";

export const PhoneNumberFieldStyled = styled.div`
  .field-label {
    color: var(--slate-blue-color);
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 6px;
  }
  width: 100%;
  margin: 5px 0px;

  .form-control {
    width: 100%;
    border-radius: 16px;
    height: 40px;
  }
  .open {
    ul {
      width: 460px;
    }
  }
  .flag-dropdown {
    border-radius: 16px 0 0 16px !important;
    .selected-flag {
      border-radius: 16px 0 0 16px !important;
    }
  }
`;
